<template>
  <div class="user">
    <div class="" v-loading="loading">
      <div class="s_wrapper">
        <el-select class="s_input" v-model="userLevel" placeholder="请选择用户等级" clearable @change="onSearch">
          <el-option v-for="(item, index) in userLevelOptions" :key="index" :label="item" :value="index"></el-option>
        </el-select>
        <el-input class="s_input" v-model="nickName" placeholder="请输入用户名称" suffix-icon="el-icon-search" @change="onSearch" clearable></el-input>
        <el-input class="s_input" v-model="userCode" placeholder="请输入用户编号" suffix-icon="el-icon-search" @change="onSearch" clearable></el-input>
        <el-select class="s_input" v-model="sex" placeholder="请选择用户性别" clearable @change="onSearch">
          <el-option v-for="(item, index) in sexOptions" :key="index" :label="item" :value="index"></el-option>
        </el-select>
      </div>

      <div class="g_table">
        <el-table :data="tableData" style="width: 100%" max-height="540">
          <el-table-column label="序号" show-overflow-tooltip width="100">
            <template slot-scope="scope">
              {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
            </template>
          </el-table-column>
          <el-table-column min-width="100" show-overflow-tooltip prop="userCode" label="用户编号"></el-table-column>
          <el-table-column min-width="100" show-overflow-tooltip prop="nickName" label="昵称"></el-table-column>
          <el-table-column min-width="100" show-overflow-tooltip prop="sex" label="性别">
            <template slot-scope="scope">
              <span>{{ sexOptions[scope.row.sex] }}</span>
            </template>
          </el-table-column>
          <el-table-column min-width="100" show-overflow-tooltip prop="phoneNum" label="电话号码">
            <template slot-scope="scope">
              <span>{{ scope.row.phoneNum || "-" }}</span>
            </template>
          </el-table-column>
          <el-table-column min-width="100" show-overflow-tooltip prop="userLevel" label="用户等级">
            <template slot-scope="scope">
              <span>{{ userLevelOptions[scope.row.userLevel] }}</span>
            </template>
          </el-table-column>
          <el-table-column min-width="100" show-overflow-tooltip prop="createdTime" label="注册时间"></el-table-column>
          <el-table-column label="操作" header-align="center" align="center" width="200">
            <template slot-scope="scope">
              <el-button class="btn" type="primary" plain @click="handleGrade(scope.row)" v-if="scope.row.userLevel == 1">等级调整</el-button>
              <el-button class="btn" type="primary" plain @click="handleSubordinate(scope.row)" v-if="scope.row.userLevel == 2">下级用户</el-button>
              <el-button class="btn" type="" plain @click="handleSeparateAccounts(scope.row)" v-if="scope.row.userLevel == 2">分账设置</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog title="分账设置" :visible.sync="separateAccountsVisible">
      <div style="display: flex; justify-content: center">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="160px" class="demo-ruleForm">
          <el-form-item label="汇付商户号：" prop="merId">
            <el-input v-model.trim="ruleForm.merId" placeholder="请输入汇付商户号"></el-input>
          </el-form-item>
          <el-form-item label="费率(%)：" prop="feeRate">
            <div style="display: flex; align-items: center">
              <el-input-number v-model="ruleForm.feeRate" placeholder="请输入费率(%)" :min="0.0" :max="100" :precision="2" :step="0.1"></el-input-number>
              <el-tooltip style="margin-left: 10px" effect="dark" content="范围值为 0%~100%" placement="right">
                <i class="el-icon-warning" style="color: #e6a23c"></i>
              </el-tooltip>
            </div>
          </el-form-item>
          <el-form-item label="提成比例(%)：" prop="commissionRate">
            <div style="display: flex; align-items: center">
              <el-input-number v-model="ruleForm.commissionRate" placeholder="请输入提成比例(%)" :min="0.0" :max="20" :precision="2" :step="0.1"></el-input-number>
              <el-tooltip style="margin-left: 10px" effect="dark" content="范围值为 0%~20%" placement="right">
                <i class="el-icon-warning" style="color: #e6a23c"></i>
              </el-tooltip>
            </div>
          </el-form-item>
        </el-form>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCancel">取 消</el-button>
        <el-button type="primary" @click="handleSubmitForm('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>
    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr" layout="prev, pager, next, jumper, sizes, total" :total="totalCount"></el-pagination>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      separateAccountsVisible: false,
      nickName: "", //姓名
      userCode: "", //用户编号
      sex: "", //性别
      userLevel: "", //等级
      tableData: [],
      sexOptions: { 0: "女", 1: "男", 2: "未知" },
      userLevelOptions: { 1: "普通用户", 2: "大团长" },
      ruleForm: {
        merId: null,
        feeRate: null,
        commissionRate: null,
      },
      rules: {
        merId: [
          { required: true, message: "请输入汇付商户号", trigger: "blur" },
          // { min: 3, max: 11, message: '长度在 3 到 11 个字符', trigger: 'blur' },
          {
            pattern: /^[1-9]\d*$/,
            message: "请输入正确的汇付商户号",
            trigger: "blur",
          },
        ],
        feeRate: [{ required: true, message: "请输入费率(%)", trigger: "blur" }],
        commissionRate: [{ required: true, message: "请输入提成比例(%)", trigger: "blur" }],
      },
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      pageSizeArr: [10, 20, 50], // 每页显示的行数(可选)
      totalCount: 0, // 总记录数（需要从后端获取）
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      this.loading = true
      try {
        const {
          result: { list, totalCount },
        } = await this.$axios.get(this.$api.userInfoList, {
          params: {
            sex: this.sex || null,
            nickName: this.nickName || null,
            userCode: this.userCode || null,
            userLevel: this.userLevel || null,
            page: this.currentPage,
            pageSize: this.pageSize,
          },
        })
        this.tableData = list
        this.totalCount = totalCount
      } catch (err) {
        this.$message.error(err.desc)
      } finally {
        this.loading = false
      }
    },
    // 等级调整
    handleGrade(row) {
      this.$confirm("此操作将对该用户升级为大团长, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .post(this.$api.userChangeLevel, {
              userId: row.userId,
              userLevel: row.userLevel == 1 ? 2 : 1,
            })
            .then(res => {
              if (res.code == 100) {
                this.$message.success("调整成功")
                this.getList()
              }
            })
            .catch(err => {
              this.$message.error(err.desc)
            })
        })
        .catch(() => {})
    },
    // 下级用户
    handleSubordinate(row) {
      this.$router.push({ name: "subordinateDet", query: { userId: row.userId } })
    },
    // 分账设置
    handleSeparateAccounts(row) {
      this.$axios
        .get(this.$api.getUserMerchant, {
          params: {
            userId: row.userId,
          },
        })
        .then(res => {
          const { code, result } = res
          if (code == 100) {
            if (result.id == null) {
              // 首次
              this.ruleForm = result
              this.$set(this.ruleForm, "feeRate", undefined)
              this.$set(this.ruleForm, "commissionRate", undefined)
            } else {
              // 编辑
              this.ruleForm = result
            }
          }
        })
        .catch(err => {
          this.$message.error(err.desc)
        })
      this.separateAccountsVisible = true
    },
    // 提交分账设置
    handleSubmitForm() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.$axios
            .post(this.$api.merchantSet, {
              bizId: this.ruleForm.userId,
              commissionRate: this.ruleForm.commissionRate,
              feeRate: this.ruleForm.feeRate,
              id: this.ruleForm.id || null,
              merId: this.ruleForm.merId,
            })
            .then(res => {
              const { code } = res
              if (code == 100) {
                this.$message.success("设置成功")
                this.separateAccountsVisible = false
                this.getList()
              }
            })
            .catch(err => {
              this.$message.error(err.desc)
            })
        } else {
          this.$message.error("请填写正确信息")
          return
        }
      })
    },
    // 取消提交分账设置
    handleCancel() {
      this.separateAccountsVisible = false
      this.ruleForm = {}
      this.$refs.ruleForm.resetFields()
    },

    // 搜索
    onSearch() {
      this.tableData = []
      this.currentPage = 1
      this.getList()
    },
    // 切换每页显示的条数
    handleSizeChange(e) {
      this.tableData = []
      this.pageSize = e
      this.getList()
    },
    // 换页
    handleCurrentChange(e) {
      this.tableData = []
      this.currentPage = e
      this.getList()
    },
  },
}
</script>

<style scoped lang="scss">
.user {
  ::v-deep .el-input-number {
    width: 100%;
  }

  ::v-deep .el-input-number__decrease {
    border-radius: 10px 0 0 10px;
  }

  ::v-deep .el-input-number__increase {
    border-radius: 0 10px 10px 0;
  }
}
</style>
